import { ISynchronizationItemMeta } from 'utils/DexieDBManager';

export const filterFavoriteSynchronizationItemMetas = (synchronizationItemMeta: ISynchronizationItemMeta[]) => {
  return synchronizationItemMeta.filter((item) => Boolean(item.starredDocumentVersionsCount));
};
